import React, {Component} from 'react';

class Footer extends Component {
    render() {
        return (
            <footer className="app-footer">
                <a href="http://hauteislands.com" target="_blank">Haute Islands</a> &copy; 2017.
                <span className="float-right">Powered by <a href="http://cakewalk.in" target="_blank">CakeWalk IT
                    Solutions</a></span>
            </footer>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js